export enum AddBomPartsToQuoteStep {
  SELECT_CONTACT = 'selectContact',
  SELECT_ITEMS_TO_COPY = 'selectItemsToCopy',
  SELECT_QUOTE = 'selectQuote',
}
